//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.0.0 (NJsonSchema v10.7.1.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class Client {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param carrierNames (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) ams-pre-dev.integritymarketing.com
     * @return Success
     */
    getCarriersAndProducts(startDate: Date, endDate: Date, agentOrAgencyAWNs: string[], v: string, carrierNames?: string[] | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AgentCarriersAndProductsResponse> {
        let url_ = this.baseUrl + "/api/producersearch/v{v}/agent/getcarriersandproducts?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (agentOrAgencyAWNs === undefined || agentOrAgencyAWNs === null)
            throw new Error("The parameter 'agentOrAgencyAWNs' must be defined and cannot be null.");
        else
            agentOrAgencyAWNs && agentOrAgencyAWNs.forEach(item => { url_ += "AgentOrAgencyAWNs=" + encodeURIComponent("" + item) + "&"; });
        if (carrierNames !== undefined && carrierNames !== null)
            carrierNames && carrierNames.forEach(item => { url_ += "CarrierNames=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetCarriersAndProducts(_response);
        });
    }

    protected processGetCarriersAndProducts(response: Response): Promise<AgentCarriersAndProductsResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgentCarriersAndProductsResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentCarriersAndProductsResponse>(null as any);
    }

    /**
     * @param carrierNames (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) ams-pre-dev.integritymarketing.com
     * @return Success
     */
    getAgentReconcileProduction(startDate: Date, endDate: Date, agentOrAgencyAWNs: string[], v: string, carrierNames?: string[] | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AgentReconcileProductionResponse> {
        let url_ = this.baseUrl + "/api/producersearch/v{v}/agent/getreconcileproduction?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "StartDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "EndDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (agentOrAgencyAWNs === undefined || agentOrAgencyAWNs === null)
            throw new Error("The parameter 'agentOrAgencyAWNs' must be defined and cannot be null.");
        else
            agentOrAgencyAWNs && agentOrAgencyAWNs.forEach(item => { url_ += "AgentOrAgencyAWNs=" + encodeURIComponent("" + item) + "&"; });
        if (carrierNames !== undefined && carrierNames !== null)
            carrierNames && carrierNames.forEach(item => { url_ += "CarrierNames=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAgentReconcileProduction(_response);
        });
    }

    protected processGetAgentReconcileProduction(response: Response): Promise<AgentReconcileProductionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgentReconcileProductionResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentReconcileProductionResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) ams-pre-dev.integritymarketing.com
     * @param body (optional) 
     * @return Success
     */
    downloadProduction(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: DownloadProductionRequest | undefined): Promise<ReportFile> {
        let url_ = this.baseUrl + "/api/producersearch/v{v}/agent/downloadproduction";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadProduction(_response);
        });
    }

    protected processDownloadProduction(response: Response): Promise<ReportFile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportFile;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportFile>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) ams-pre-dev.integritymarketing.com
     * @param body (optional) 
     * @return Success
     */
    getPolicySnapShotData(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: PolicySnapShotRequest | undefined): Promise<PolicySnapShotProductionResponse> {
        let url_ = this.baseUrl + "/api/producersearch/v{v}/agent/getpolicysnapshotdata";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPolicySnapShotData(_response);
        });
    }

    protected processGetPolicySnapShotData(response: Response): Promise<PolicySnapShotProductionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PolicySnapShotProductionResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PolicySnapShotProductionResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) ams-pre-dev.integritymarketing.com
     * @param body (optional) 
     * @return Success
     */
    downloadPolicySnapShotReport(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: PolicySnapShotRequest | undefined): Promise<ReportFile> {
        let url_ = this.baseUrl + "/api/producersearch/v{v}/agent/downloadpolicysnapshotreport";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadPolicySnapShotReport(_response);
        });
    }

    protected processDownloadPolicySnapShotReport(response: Response): Promise<ReportFile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportFile;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportFile>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) ams-pre-dev.integritymarketing.com
     * @param body (optional) 
     * @return Success
     */
    getPolicyManagementData(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: PolicySnapShotRequest | undefined): Promise<PolicyManagementProductionResponse> {
        let url_ = this.baseUrl + "/api/producersearch/v{v}/agent/getpolicymanagementdata";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetPolicyManagementData(_response);
        });
    }

    protected processGetPolicyManagementData(response: Response): Promise<PolicyManagementProductionResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PolicyManagementProductionResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PolicyManagementProductionResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) ams-pre-dev.integritymarketing.com
     * @param body (optional) 
     * @return Success
     */
    getAutoRTSData(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: AutoRTSRequest | undefined): Promise<AutoRTSResponse> {
        let url_ = this.baseUrl + "/api/producersearch/v{v}/agent/getautortsdata";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAutoRTSData(_response);
        });
    }

    protected processGetAutoRTSData(response: Response): Promise<AutoRTSResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AutoRTSResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AutoRTSResponse>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) ams-pre-dev.integritymarketing.com
     * @param body (optional) 
     * @return Success
     */
    getProductionReconcileReport(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined, body?: ProductionReconcileReportRequest | undefined): Promise<ReportFile> {
        let url_ = this.baseUrl + "/api/producersearch/v{v}/reports/getproductionreconcilereport";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetProductionReconcileReport(_response);
        });
    }

    protected processGetProductionReconcileReport(response: Response): Promise<ReportFile> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportFile;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportFile>(null as any);
    }

    /**
     * @param searchType (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) ams-pre-dev.integritymarketing.com
     * @return Success
     */
    getAllAgent(v: string, searchType?: number | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AgentSearchResponse> {
        let url_ = this.baseUrl + "/api/producersearch/v{v}/agents?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (searchType === null)
            throw new Error("The parameter 'searchType' cannot be null.");
        else if (searchType !== undefined)
            url_ += "SearchType=" + encodeURIComponent("" + searchType) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllAgent(_response);
        });
    }

    protected processGetAllAgent(response: Response): Promise<AgentSearchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgentSearchResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentSearchResponse>(null as any);
    }

    /**
     * @param searchType (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) ams-pre-dev.integritymarketing.com
     * @return Success
     */
    getAllAgentsLookup(v: string, searchType?: number | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AgentLookupSearchResponse> {
        let url_ = this.baseUrl + "/api/producersearch/v{v}/agents/lookup?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (searchType === null)
            throw new Error("The parameter 'searchType' cannot be null.");
        else if (searchType !== undefined)
            url_ += "SearchType=" + encodeURIComponent("" + searchType) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllAgentsLookup(_response);
        });
    }

    protected processGetAllAgentsLookup(response: Response): Promise<AgentLookupSearchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgentLookupSearchResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentLookupSearchResponse>(null as any);
    }

    /**
     * @param searchType (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) ams-pre-dev.integritymarketing.com
     * @return Success
     */
    getAllMarketersLookup(v: string, searchType?: number | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<MarketerLookupSearchResponse> {
        let url_ = this.baseUrl + "/api/producersearch/v{v}/agents/marketerlookup?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (searchType === null)
            throw new Error("The parameter 'searchType' cannot be null.");
        else if (searchType !== undefined)
            url_ += "SearchType=" + encodeURIComponent("" + searchType) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllMarketersLookup(_response);
        });
    }

    protected processGetAllMarketersLookup(response: Response): Promise<MarketerLookupSearchResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MarketerLookupSearchResponse;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketerLookupSearchResponse>(null as any);
    }

    /**
     * @param markterId (optional) 
     * @param companyId (optional) 
     * @param agentId (optional) 
     * @param stateAbbreviation (optional) 
     * @param zip (optional) 
     * @param excludeDNC (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) ams-pre-dev.integritymarketing.com
     * @return Success
     */
    getAllAgentsByMap(v: string, markterId?: number | undefined, companyId?: number | undefined, agentId?: number | undefined, stateAbbreviation?: string | null | undefined, zip?: string | null | undefined, excludeDNC?: boolean | undefined,county?: string | null | undefined,  impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AgentMapViewSPModel[]> {
        let url_ = this.baseUrl + "/api/producersearch/v{v}/agents/maps?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (markterId === null)
            throw new Error("The parameter 'markterId' cannot be null.");
        else if (markterId !== undefined)
            url_ += "MarkterId=" + encodeURIComponent("" + markterId) + "&";
        if (companyId === null)
            throw new Error("The parameter 'companyId' cannot be null.");
        else if (companyId !== undefined)
            url_ += "CompanyId=" + encodeURIComponent("" + companyId) + "&";
        if (agentId === null)
            throw new Error("The parameter 'agentId' cannot be null.");
        else if (agentId !== undefined)
            url_ += "AgentId=" + encodeURIComponent("" + agentId) + "&";
        if (stateAbbreviation !== undefined && stateAbbreviation !== null)
            url_ += "StateAbbreviation=" + encodeURIComponent("" + stateAbbreviation) + "&";
        if (zip !== undefined && zip !== null)
            url_ += "Zip=" + encodeURIComponent("" + zip) + "&";
        if (county !== undefined && county !== null)
            url_ += "County=" + encodeURIComponent("" + county) + "&";
        if (excludeDNC === null)
            throw new Error("The parameter 'excludeDNC' cannot be null.");
        else if (excludeDNC !== undefined)
            url_ += "ExcludeDNC=" + encodeURIComponent("" + excludeDNC) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAllAgentsByMap(_response);
        });
    }

    protected processGetAllAgentsByMap(response: Response): Promise<AgentMapViewSPModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgentMapViewSPModel[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AgentMapViewSPModel[]>(null as any);
    }

    /**
     * @param county (optional) 
     * @param state (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) ams-pre-dev.integritymarketing.com
     * @return Success
     */
    getZipCodeByCountyState(v: string, county?: string | null | undefined, state?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/producersearch/v{v}/agents/zip?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (county !== undefined && county !== null)
            url_ += "County=" + encodeURIComponent("" + county) + "&";
        if (state !== undefined && state !== null)
            url_ += "State=" + encodeURIComponent("" + state) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetZipCodeByCountyState(_response);
        });
    }

    protected processGetZipCodeByCountyState(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) ams-pre-dev.integritymarketing.com
     * @return Success
     */
    marketersForMaps(v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ListItem[]> {
        let url_ = this.baseUrl + "/api/producersearch/v{v}/agents/marketersformaps";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processMarketersForMaps(_response);
        });
    }

    protected processMarketersForMaps(response: Response): Promise<ListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ListItem[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListItem[]>(null as any);
    }

    /**
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) ams-pre-dev.integritymarketing.com
     * @return Success
     */
    getAgentOrAgencyDetailsById(agentorAgencyId: number, v: string, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AgentOrAgencyDetails> {
        let url_ = this.baseUrl + "/api/producersearch/v{v}/agents/{agentorAgencyId}/agentoragencylookup";
        if (agentorAgencyId === undefined || agentorAgencyId === null)
            throw new Error("The parameter 'agentorAgencyId' must be defined.");
        url_ = url_.replace("{agentorAgencyId}", encodeURIComponent("" + agentorAgencyId));
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAgentOrAgencyDetailsById(_response);
        });
    }

    protected processGetAgentOrAgencyDetailsById(response: Response): Promise<AgentOrAgencyDetails> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AgentOrAgencyDetails;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else {
            return response.text().then((_responseText) => {
            let resultdefault: any = null;
            resultdefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProblemDetails;
            return throwException("Error", status, _responseText, _headers, resultdefault);
            });
        }
    }

    /**
     * @param year (optional) 
     * @param carrierIds (optional) 
     * @param agentId (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) ams-pre-dev.integritymarketing.com
     * @return Success
     */
    getAutoRtsByNpn(v: string, year?: number | undefined, carrierIds?: string[] | null | undefined, agentId?: number | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<AutoRtsByAgentResponse[]> {
        let url_ = this.baseUrl + "/api/producersearch/v{v}/agents/getautortsbynpn?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (carrierIds !== undefined && carrierIds !== null)
            carrierIds && carrierIds.forEach(item => { url_ += "CarrierIds=" + encodeURIComponent("" + item) + "&"; });
        if (agentId === null)
            throw new Error("The parameter 'agentId' cannot be null.");
        else if (agentId !== undefined)
            url_ += "AgentId=" + encodeURIComponent("" + agentId) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetAutoRtsByNpn(_response);
        });
    }

    protected processGetAutoRtsByNpn(response: Response): Promise<AutoRtsByAgentResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AutoRtsByAgentResponse[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AutoRtsByAgentResponse[]>(null as any);
    }

    /**
     * @param year (optional) 
     * @param carrierIds (optional) 
     * @param agentId (optional) 
     * @param pageIndex (optional) 
     * @param pageSize (optional) 
     * @param sortColumn (optional) 
     * @param sortAscending (optional) 
     * @param fullTextFilter (optional) 
     * @param impersonated_User (optional) 
     * @param hOSTNAME (optional) ams-pre-dev.integritymarketing.com
     * @return Success
     */
    downloadAutoRtsByNpn(v: string, year?: number | undefined, carrierIds?: string[] | null | undefined, agentId?: number | undefined, pageIndex?: number | undefined, pageSize?: number | undefined, sortColumn?: string | null | undefined, sortAscending?: boolean | undefined, fullTextFilter?: string | null | undefined, impersonated_User?: any | undefined, hOSTNAME?: any | undefined): Promise<ReportFile[]> {
        let url_ = this.baseUrl + "/api/producersearch/v{v}/agents/downloadautortsbynpn?";
        if (v === undefined || v === null)
            throw new Error("The parameter 'v' must be defined.");
        url_ = url_.replace("{v}", encodeURIComponent("" + v));
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (carrierIds !== undefined && carrierIds !== null)
            carrierIds && carrierIds.forEach(item => { url_ += "CarrierIds=" + encodeURIComponent("" + item) + "&"; });
        if (agentId === null)
            throw new Error("The parameter 'agentId' cannot be null.");
        else if (agentId !== undefined)
            url_ += "AgentId=" + encodeURIComponent("" + agentId) + "&";
        if (pageIndex === null)
            throw new Error("The parameter 'pageIndex' cannot be null.");
        else if (pageIndex !== undefined)
            url_ += "PageIndex=" + encodeURIComponent("" + pageIndex) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortColumn !== undefined && sortColumn !== null)
            url_ += "SortColumn=" + encodeURIComponent("" + sortColumn) + "&";
        if (sortAscending === null)
            throw new Error("The parameter 'sortAscending' cannot be null.");
        else if (sortAscending !== undefined)
            url_ += "SortAscending=" + encodeURIComponent("" + sortAscending) + "&";
        if (fullTextFilter !== undefined && fullTextFilter !== null)
            url_ += "FullTextFilter=" + encodeURIComponent("" + fullTextFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Impersonated_User": impersonated_User !== undefined && impersonated_User !== null ? "" + impersonated_User : "",
                "HOSTNAME": hOSTNAME !== undefined && hOSTNAME !== null ? "" + hOSTNAME : "",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processDownloadAutoRtsByNpn(_response);
        });
    }

    protected processDownloadAutoRtsByNpn(response: Response): Promise<ReportFile[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReportFile[];
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("If Authorization header not present, has no value or no valid jwt bearer token", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("If user not authorized to perform requested action", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReportFile[]>(null as any);
    }
}

export interface TopCarrier {
    carrierName?: string | undefined;
    appCount?: number;
    annualizedPremium?: string | undefined;
    sortedAnnualizedPremium?: number;
}

export interface TopProduct {
    productName?: string | undefined;
    appCount?: number;
    annualizedPremium?: string | undefined;
    sortedAnnualizedPremium?: number;
}

export interface AgentCarriersAndProductsModel {
    agentorAgencyCount?: number | undefined;
    agentorAgencyNPN?: string | undefined;
    readonly carrierCount?: number;
    readonly productTypeCount?: number;
    businessUnit?: string | undefined;
    topCarriers?: TopCarrier[] | undefined;
    carrierAnnualizedPremiumTotal?: string | undefined;
    topProducts?: TopProduct[] | undefined;
    productAnnualizedPremiumTotal?: string | undefined;
}

export interface AgentCarriersAndProductsResponse {
    title?: string | undefined;
    data?: AgentCarriersAndProductsModel;
}

export interface YearOverYear_1OfOfInt32AndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    month?: number;
    currentYear?: number;
    previousYear?: number;
}

export interface YearOverYear_1OfOfDecimalAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    month?: number;
    currentYear?: number;
    previousYear?: number;
}

export interface AgentReconcileProductionModel {
    agentorAgencyCount?: number | undefined;
    agentorAgencyNPN?: string | undefined;
    readonly carrierCount?: number;
    readonly productTypeCount?: number;
    businessUnit?: string | undefined;
    topCarriers?: TopCarrier[] | undefined;
    carrierAnnualizedPremiumTotal?: string | undefined;
    topProducts?: TopProduct[] | undefined;
    productAnnualizedPremiumTotal?: string | undefined;
    appCountYearOverYear?: YearOverYear_1OfOfInt32AndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[] | undefined;
    annualizedPremiumYearOverYear?: YearOverYear_1OfOfDecimalAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[] | undefined;
}

export interface AgentReconcileProductionResponse {
    title?: string | undefined;
    data?: AgentReconcileProductionModel;
}

export interface DownloadProductionRequest {
    pageIndex?: number;
    pageSize?: number;
    readonly skip?: number;
    readonly take?: number;
    sortColumn?: string | undefined;
    sortAscending?: boolean;
    fullTextFilter?: string | undefined;
    apiUrl?: string | undefined;
    buName?: string | undefined;
    sortOrder?: string | undefined;
    pageCount?: number;
    startDate?: Date;
    endDate?: Date;
    npn?: string | undefined;
    downline?: string | undefined;
    productionType?: string | undefined;
    carrier?: string | undefined;
    searchText?: string | undefined;
    status?: string | undefined;
}

export interface ReportFile {
    title?: string | undefined;
    data?: string | undefined;
    contentType?: string | undefined;
    fileName?: string | undefined;
}

export interface PolicySnapShotRequest {
    pageIndex?: number;
    pageSize?: number;
    readonly skip?: number;
    readonly take?: number;
    sortColumn?: string | undefined;
    sortAscending?: boolean;
    fullTextFilter?: string | undefined;
    apiUrl?: string | undefined;
    buName?: string | undefined;
    startDate?: Date;
    endDate?: Date;
    npn?: string | undefined;
    downline?: string | undefined;
    carrier?: string | undefined;
    searchText?: string | undefined;
    status?: string | undefined;
    statusType?: number;
    dateType?: string | undefined;
}

export interface PolicySnapShotDataResponse {
    policyEffectiveDate?: string | undefined;
    policyNumber?: string | undefined;
    premium?: string | undefined;
    agentName?: string | undefined;
    carrierName?: string | undefined;
    planName?: string | undefined;
    productTypeName?: string | undefined;
    consumerName?: string | undefined;
    awn?: string | undefined;
    policyStaus?: string | undefined;
    submiteDate?: string | undefined;
    confirmationDate?: string | undefined;
    annualPremium?: string | undefined;
    confirmationId?: string | undefined;
    rowCount?: number;
}

export interface PolicySnapShotProductionResponse {
    title?: string | undefined;
    data?: PolicySnapShotDataResponse[] | undefined;
}

export interface PolicyManagementDataResponse {
    submiT_DATE?: string | undefined;
    effectivE_DATE?: string | undefined;
    policY_NUMBER?: string | undefined;
    policY_STATUS?: string | undefined;
    carrier?: string | undefined;
    producT_TYPE?: string | undefined;
    agenT_WRITING_NUMBER?: string | undefined;
    agenT_NAME?: string | undefined;
    consumeR_NAME?: string | undefined;
    confirmatioN_NUMBER?: string | undefined;
    leaD_DATE?: string | undefined;
    leaD_STATUS?: string | undefined;
    applicatioN_START_DATE?: string | undefined;
    enrollmenT_PLAN_YEAR?: number | undefined;
    prE_ENROLLMENT_DATE?: string | undefined;
    prE_ENROLLMENT_STATUS?: string | undefined;
    issuE_DATE?: string | undefined;
    terM_DATE?: string | undefined;
    renewaL_DATE?: string | undefined;
    internaL_POLICY?: string | undefined;
    facE_AMOUNT?: number | undefined;
    annuaL_PREMIUM?: number | undefined;
    paymenT_FREQUENCY?: number | undefined;
    iS_NEWAPP?: boolean | undefined;
    iS_INTERNAL?: boolean | undefined;
    firsT_STATEMENT_DATE?: string | undefined;
    initiaL_ANNUAL_PREMIUM?: number | undefined;
    product?: string | undefined;
    plaN_NAME?: string | undefined;
}

export interface PolicyManagementProductionResponse {
    title?: string | undefined;
    total?: number;
    applied?: number;
    issued?: number;
    declined?: number;
    recordCount?: number;
    data?: PolicyManagementDataResponse[] | undefined;
}

export interface AutoRTSRequest {
    carriers?: string[] | undefined;
    npn?: string | undefined;
    buname?: string | undefined;
}

export interface AutoRTSResponseData {
    npn?: string | undefined;
    carrieR_GROUP_NAME?: string | undefined;
    awnwritingnumber?: string | undefined;
    statecode?: string | undefined;
    producT_TYPE_NAME?: string | undefined;
    rtS_STATUS?: string | undefined;
    plaN_YEAR?: number;
    certificationdate?: string | undefined;
    appointmentdate?: string | undefined;
    iS_SELF_ATTESTED?: string | undefined;
    selF_ATTESTATION_DATE?: string | undefined;
}

export interface AutoRTSResponse {
    title?: string | undefined;
    recordCount?: number;
    data?: AutoRTSResponseData[] | undefined;
}

export enum FileType {
    _0 = 0,
    _1 = 1,
}

export interface ProductionReconcileReportRequest {
    fileType: FileType;
    startDate: Date;
    endDate: Date;
    agentOrAgencyAWNs: string[];
    carrierNames?: string[] | undefined;
    carrierName?: string | undefined;
    productNames?: string[] | undefined;
    productCategories?: string[] | undefined;
    productTypes?: string[] | undefined;
}

export interface AgentListModel {
    id?: number;
    name?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    nickname?: string | undefined;
    suffix?: string | undefined;
    city?: string | undefined;
    zip?: string | undefined;
    state?: string | undefined;
    county?: string | undefined;
    agentNumber?: string | undefined;
    dba?: string | undefined;
    npn?: string | undefined;
    isAgency?: boolean;
    licenseId?: number;
    status?: string | undefined;
}

export interface AgentSearchResponse {
    recordCount?: number;
    data?: AgentListModel[] | undefined;
}

export interface AgentLookupModel {
    id?: number;
    name?: string | undefined;
    npn?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    status?: string | undefined;
    isAgency?: boolean;
    awNs?: string[] | undefined;
}

export interface AgentLookupSearchResponse {
    recordCount?: number;
    data?: AgentLookupModel[] | undefined;
}

export interface MarketerLookupModel {
    id?: number;
    name?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
}

export interface MarketerLookupSearchResponse {
    recordCount?: number;
    data?: MarketerLookupModel[] | undefined;
}

export interface AgentMapViewSPModel {
    agentId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    cityName?: string | undefined;
    stateAbbreviation?: string | undefined;
    zipCode?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    readonly mapViewString?: string | undefined;
}

export interface ListItem {
    value?: string | undefined;
    text?: string | undefined;
    selected?: boolean;
}

export interface Carrier {
    carrierId?: number;
    carrierName?: string | undefined;
}

export interface Data {
    agentOrAgencyAWNs?: string[] | undefined;
    agentOrAgencyNPN?: string | undefined;
    carriers?: Carrier[] | undefined;
}

export interface AgentOrAgencyDetails {
    agentOrAgencyCount?: number;
    status?: string | undefined;
    message?: string | undefined;
    data?: Data;
}

export interface ProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
}

export interface AutoRtsModel {
    npn?: string | undefined;
    bu?: string | undefined;
    bU_FULL_NAME?: string | undefined;
    carrier?: string | undefined;
    awn?: string | undefined;
    state?: string | undefined;
    product?: string | undefined;
    tin?: string | undefined;
    rtS_STATUS?: string | undefined;
    plaN_YEAR?: number;
    appointmenT_DATE?: string | undefined;
    selF_ATTESTATION_DATE?: string | undefined;
    certificatioN_DATE?: string | undefined;
    iS_SELF_ATTESTED?: string | undefined;
    title?: string | undefined;
}

export interface AutoRtsByAgentResponse {
    recordCount?: number;
    data?: AutoRtsModel[] | undefined;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}